import { render, staticRenderFns } from "./newsInformation.vue?vue&type=template&id=4f94e1b0&scoped=true&"
import script from "./newsInformation.vue?vue&type=script&lang=js&"
export * from "./newsInformation.vue?vue&type=script&lang=js&"
import style0 from "./newsInformation.vue?vue&type=style&index=0&id=4f94e1b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f94e1b0",
  null
  
)

export default component.exports